module.exports = __webpack_public_path__ + "img/wave.39a2d31.svg";